export default __webpack_public_path__ + "images/02f677551b1acb6e0d3a1596593b6969.svg";